import keyMirror from 'keymirror'

export default keyMirror({
  GET_SCW_PATENTS_REQUEST: null,
  GET_SCW_PATENTS_SUCCESS: null,
  GET_SCW_PATENTS_FAILED: null,

  GET_SCW_PATENT_DETAIL_REQUEST: null,
  GET_SCW_PATENT_DETAIL_SUCCESS: null,
  GET_SCW_PATENT_DETAIL_FAILED: null,

  DELETE_SCW_PATENT_REQUEST: null,
  DELETE_SCW_PATENT_SUCCESS: null,
  DELETE_SCW_PATENT_FAILED: null,

  ADD_SCW_PATENT_REQUEST: null,
  ADD_SCW_PATENT_SUCCESS: null,
  ADD_SCW_PATENT_FAILED: null,

  UPDATE_SCW_PATENT_REQUEST: null,
  UPDATE_SCW_PATENT_SUCCESS: null,
  UPDATE_SCW_PATENT_FAILED: null,

  UPDATE_SCW_PATENT_STATUS_REQUEST: null,
  UPDATE_SCW_PATENT_STATUS_SUCCESS: null,
  UPDATE_SCW_PATENT_STATUS_FAILED: null,

  UPDATE_FILTER_SCW_PATENT_SUCCESS: null,

  UPDATE_SCW_PATENT_SELECTED_LANGUAGES_SUCCESS: null,

  UPSERT_SCW_PATENT_TRANSLATION_REQUEST: null,
  UPSERT_SCW_PATENT_TRANSLATION_SUCCESS: null,
  UPSERT_SCW_PATENT_TRANSLATION_FAILED: null,

  GET_SCW_PATENT_CONTENT_REQUEST: null,
  GET_SCW_PATENT_CONTENT_SUCCESS: null,
  GET_SCW_PATENT_CONTENT_FAILED: null
})
